import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Switch,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import MUIDataTable from "mui-datatables";
import AddIcon from "@mui/icons-material/Add";
import Loader from "../../../../components/loader/Loader";
import { useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import { grey } from "@mui/material/colors";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  hideConfirmModal,
  showConfirmModal,
  showModal,
} from "../../../../redux/counterSlice";
import { FormAutoComplete } from "../../../../components/form-components/FormAutoComplete";
import { parseArray } from "../../../../app/utlils";
import { FormInputText } from "../../../../components/form-components/FormInputText";

const Configuration = () => {
  const dispatch = useDispatch();

  const methods = useForm();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = methods;

  const [loader, setLoader] = useState(true);
  const [formData, setFormData] = useState([]);
  const [productList, setProductList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const loadInitialData = async () => {
    try {
      setLoader(true);
      const [allDiscountCategoryList, allActiveDiscountList] = await axios.all([
        axios.get("/configurations"),
        axios.get("/activeProductList"),
      ]);
      allDiscountCategoryList?.data?.data?.length > 0 &&
        setFormData(allDiscountCategoryList?.data?.data);
      allActiveDiscountList?.data?.data?.length > 0 &&
        setProductList(allActiveDiscountList?.data?.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoader(false);
      dispatch(hideConfirmModal({ msg: "" }));
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const columns = [
    {
      name: "id",
      label: "S. No",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return <p>{+dataIndex + 1}</p>;
        },
      },
    },
    {
      name: "config_name",
      label: "Config Name",
      options: {
        customBodyRenderLite: (dataIndex) => {
          return <p>{formData[dataIndex]?.config_name}</p>;
        },
      },
    },

    {
      name: "data",
      label: "Configuration Data [Search Place Holder]",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const config = formData[dataIndex];
          const rawData = config?.data || "";

          // Handle comma-separated values as pills
          const values = rawData.split(",").map((item) => item.trim());
          const maxPills = 3;
          const pills = values.slice(0, maxPills).map((value, idx) => (
            <span
              key={idx}
              title={rawData}
              style={{
                display: "inline-block",
                background: "#e0e7ff",
                color: "#3730a3",
                borderRadius: "16px",
                padding: "2px 10px",
                marginRight: "4px",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              {value}
            </span>
          ));

          const extraCount = values.length - maxPills;

          return (
            <span>
              {pills}
              {extraCount > 0 && (
                <span
                  style={{
                    display: "inline-block",
                    background: "#fca5a5",
                    color: "#991b1b",
                    borderRadius: "16px",
                    padding: "2px 10px",
                    fontSize: "12px",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  title={rawData}
                >
                  +{extraCount} more
                </span>
              )}
            </span>
          );
        },
      },
    },
    {
      name: "active_status",
      label: "Status",
      options: {
        display: false,
        customBodyRenderLite: (dataIndex) => {
          const status = formData[dataIndex]?.active_status;
          return (
            <Switch
              size="small"
              color={status === 1 ? "success" : "error"}
              checked={status === 1 ? true : false}
              onChange={() => {
                dispatch(
                  showConfirmModal({
                    msg: status === 1 ? "Deactivate" : "Activate",
                    action: () =>
                      toggleStatus(
                        formData[dataIndex]?.id,
                        formData[dataIndex]?.active_status
                      ),
                  })
                );
              }}
              style={{ marginBottom: "5px" }}
            />
          );
        },
      },
    },

    {
      name: "Edit",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const status = formData[dataIndex]?.active_status;

          return (
            <div className="actionBtns">
              <Button
                disabled={status === 1 ? true : false}
                aria-label="edit"
                onClick={() => editClickHandler(formData[dataIndex])}
              >
                <EditIcon
                  fontSize="medium"
                  sx={{ color: status === 1 ? grey[600] : "secondary" }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];
  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
    reset();
  };
  const editClickHandler = (item) => {
    setOpen(true);
    setSelectedRow({ ...item });
  };
  const onSubmit = (data) => {
    saveForm(data);
  };

  const toggleStatus = (id) => {
    setLoader(true);
    axios
      .get("/configurations/" + id)
      .then(function (response) {
        if (!response?.data?.error) {
          toast.success(response?.data?.message);
          loadInitialData();
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const deleteClickHandler = async (id) => {
    setLoader(true);
    try {
      if (id) {
        const response = await axios.delete("/configurations/" + id);
        if (!response?.data?.error) {
          toast.success(response?.data?.message);
          loadInitialData();
        } else {
          let errDesc = "";
          if (response?.data?.data) {
            Object.values(response?.data?.data).map((error, index) => {
              errDesc =
                index === 0 ? errDesc + error + "\n " : errDesc + error + "\n ";
            });
          } else {
            errDesc = response?.data?.message;
          }

          dispatch(
            showModal({
              msg: errDesc,
              error: response?.data?.error,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        })
      );
    } finally {
      setLoader(false);
    }
  };

  const saveForm = async (data) => {
    setLoader(true);
    try {
      let response;

      // Extract product names from selected products
      const selectedProducts = parseArray(data?.product);
      const productNames = selectedProducts
        .map((productId) => {
          const product = productList.find((p) => p?.id === productId);
          return product?.product_name;
        })
        .filter(Boolean)
        .join(",");

      const payload = {
        config_name: data?.config_name || "",
        data: productNames,
      };

      if (selectedRow?.id) {
        response = await axios.put(
          "/configurations/" + selectedRow?.id,
          payload
        );
      } else {
        response = await axios.post("/configurations", payload);
      }

      if (!response?.data?.error) {
        toast.success(response?.data?.message);
        loadInitialData();
        setOpen(false);
        setSelectedRow(null);
        reset();
      } else {
        let errDesc = "";
        if (response?.data?.data) {
          Object.values(response?.data?.data).map((error, index) => {
            errDesc =
              index === 0 ? errDesc + error + "\n " : errDesc + error + "\n ";
          });
        } else {
          errDesc = response?.data?.message;
        }

        dispatch(
          showModal({
            msg: errDesc,
            error: response?.data?.error,
          })
        );
        setOpen(false);
      }
    } catch (error) {
      dispatch(
        showModal({
          msg: error?.message,
          error: true,
        })
      );
      setOpen(false);
    } finally {
      setLoader(false);
    }
  };

  const CreateEditDialog = React.memo(() => {
    return (
      <Dialog open={open} onClose={handleClose} maxWidth={"sm"} fullWidth>
        <DialogTitle className="text-primary">
          {selectedRow ? "Edit Configuration" : "New Configuration"}
        </DialogTitle>
        <DialogContent>
          <Grid container columnSpacing={{ xs: 5 }}>
            <Grid item xs={12}>
              <FormInputText
                name="config_name"
                control={control}
                label="Configuration Name"
                errors={errors}
                defaultValue={selectedRow?.config_name || ""}
                mandatory="true"
              />
            </Grid>
            <Grid item xs={12}>
              <FormAutoComplete
                name="product"
                control={control}
                label="Product"
                multiple={true}
                dataArray={productList?.map((item) => ({
                  value: item?.id,
                  label: item?.product_name,
                }))}
                errors={errors}
                defaultValue={
                  selectedRow?.data
                    ?.split(",")
                    .map((name) => {
                      const product = productList.find(
                        (p) => p?.product_name === name.trim()
                      );
                      return product
                        ? { value: product?.id, label: product?.product_name }
                        : null;
                    })
                    .filter(Boolean) || []
                }
                mandatory="true"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="error">
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            startIcon={<SaveIcon />}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  });

  const options = {
    selectableRows: false,
    filter: false,
    download: true,
    viewColumns: true,
    print: false,
  };
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <h4 className="text-dark">Configuration</h4>
          <MUIDataTable
            data={formData?.length > 0 ? formData : []}
            columns={columns}
            options={options}
            title={
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  setSelectedRow(null);
                  setOpen(true);
                  reset();
                }}
                icon={<AddIcon />}
              >
                New Configuration
              </Button>
            }
          />
        </>
      )}
      <CreateEditDialog />
    </>
  );
};

export default Configuration;
